import React from "react";
import { useIntl } from "react-intl";
import { motion } from "framer-motion";
import styled from "styled-components";
import { TGetServicesCollectionItem } from "../../../../api/service/service.types";
import useFooter from "../../../../util/useFooter";
import useHeader from "../../../../util/useHeader";
import usePageTitle from "../../../../util/usePageTitle";
import VariableContainer from "../../components/VariableContainer";
import ServiceHeader from "./components/ServiceHeader";
import ServiceInfoPanel from "../../features/service/components/ServiceInfoPanel";
import ServiceMorePanel from "./components/ServiceMorePanel";
import ServiceValuation from "./components/ServiceValuation";
import LeftHiddablePanel from "./components/ServiceValuation/components/LeftHiddablePanel";
import { TServicePageTab } from "./ServicePageContainer";

const StyledPageContainer = styled.div`
  margin: 0;
  padding: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;

const StyledHeaderWrapper = styled.div``;

const StyledContentWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  align-items: stretch;
`;

const StyledMainWrapper = styled.div`
  flex-grow: 1;
`;

const StyledAdditionalInfoWrapper = styled.div`
  width: 16rem;
  min-width: 16rem;
  background-color: rgb(250, 251, 252);
`;

const headerVariants = {
  enter: {
    opacity: 1,
    transition: { duration: 0.25 },
    delay: 50,
    y: 0,
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.1 },
    y: -15,
  },
};

interface IServicePageProps {
  service: TGetServicesCollectionItem;
  isLoading: boolean;
  onTabChange: (event: React.ChangeEvent<{}>, string: any) => void;
  tab: TServicePageTab;
  windowWidth: number;
  valuationNotes: string;
  onValuationNotesChange: (notes: string) => void;
  pathologyOptions: { value: string; label: string }[];
}

const ServicePage = (props: IServicePageProps) => {
  const {
    service,
    onTabChange,
    tab,
    windowWidth,
    valuationNotes,
    onValuationNotesChange,
    pathologyOptions,
  } = props;
  const { formatMessage } = useIntl();

  useHeader({
    type: "hidden",
  });
  useFooter({
    type: "hidden",
  });

  usePageTitle(
    service && service.Name
      ? service.Name
      : formatMessage({
          id: "ServicePage.ServicePage",
          defaultMessage: "Servicio",
        })
  );

  return (
    <StyledPageContainer>
      <StyledHeaderWrapper>
        <motion.div initial="exit" animate="enter" variants={headerVariants}>
          <ServiceHeader service={service} />
        </motion.div>
      </StyledHeaderWrapper>
      <VariableContainer>
        <StyledContentWrapper>
          <LeftHiddablePanel>
            <ServiceInfoPanel service={service} />
          </LeftHiddablePanel>
          <StyledMainWrapper>
            <ServiceValuation
              service={service}
              valuationNotes={valuationNotes}
              pathologyOptions={pathologyOptions}
            />
          </StyledMainWrapper>
          {windowWidth > 1440 && (
            <StyledAdditionalInfoWrapper>
              <ServiceMorePanel
                tab={tab}
                onTabChange={onTabChange}
                service={service}
                valuationNotes={valuationNotes}
                onValuationNotesChange={onValuationNotesChange}
              />
            </StyledAdditionalInfoWrapper>
          )}
        </StyledContentWrapper>
      </VariableContainer>
    </StyledPageContainer>
  );
};

export default ServicePage;
